import { useState, useCallback } from 'react';
import { ChevronDown } from 'lucide-react';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { Button } from '@/components/ui/button';
import { Textarea } from '@/components/ui/textarea';

interface IDeliveryStyleBadgeProps {
  onSave: (prompt: string) => void;
}

function DeliveryStyleBadge({ onSave }: IDeliveryStyleBadgeProps) {
  const [prompt, setPrompt] = useState('');

  const handleSave = useCallback(() => {
    const trimmed = prompt.trim();
    if (trimmed) {
      onSave(trimmed);
      setPrompt('');
    }
  }, [prompt, onSave]);

  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          className="mt-1.5 flex items-center gap-1 rounded-md bg-background-secondary/60 px-1.5 py-0.5 text-xs text-foreground-muted transition-colors hover:bg-background-secondary"
          onClick={(e) => e.stopPropagation()}
        >
          Delivery style
          <ChevronDown className="size-2.5" />
        </button>
      </PopoverTrigger>
      <PopoverContent
        align="start"
        className="w-56 p-3"
        onClick={(e) => e.stopPropagation()}
      >
        <p className="mb-2 text-sm font-medium">Delivery Style Prompt</p>
        <Textarea
          value={prompt}
          onChange={(e) => setPrompt(e.target.value)}
          placeholder="e.g. Excited, energetic tone..."
          className="mb-2 min-h-16 text-sm"
        />
        <Button size="sm" className="w-full" onClick={handleSave}>
          Apply
        </Button>
      </PopoverContent>
    </Popover>
  );
}

export { DeliveryStyleBadge };
